export default __webpack_public_path__ + "static/media/franchise-template-4.211741e7.svg";